import { CreateUserIcon } from 'components/Icon'
import { Button, Flex } from 'theme-ui'

export type CreateStudentBtnProps = {
  handleCreateStudentClick: () => void
}

export function CreateStudentBtn({
  handleCreateStudentClick,
}: CreateStudentBtnProps) {
  return (
    <Flex data-cy="create-student" sx={{ alignItems: 'center' }}>
      <Button
        id="create-student-mobile-btn"
        sx={{
          bg: 'white',
          width: 40,
          height: 40,
          px: 0,
          py: 0,
          borderRadius: '100%',
          display: ['inline-block', 'none'],
        }}
        disabled={!handleCreateStudentClick}
        onClick={handleCreateStudentClick}>
        <CreateUserIcon />
      </Button>
      <Button
        id="create-student-btn"
        variant="buttons.outlineWhite"
        sx={{
          px: [20, 20],
          py: [0, 0, 0],
          height: 50,
          m: 'auto',
          display: ['none', 'inline-block'],
          minWidth: 145,
        }}
        disabled={!handleCreateStudentClick}
        onClick={handleCreateStudentClick}>
        + New student
      </Button>
    </Flex>
  )
}
